import React from 'react';
import { SupportChatDisabled } from '../features/SupportChat/SupportChatGate';
import SupportChatWindow from '../features/SupportChat/SupportChatWindow';

const SupportChat = () => {
  if (process.env.REACT_APP_FEATURE_SUPPORT_CHAT !== 'true') {
    return <SupportChatDisabled />;
  }

  return <SupportChatWindow />;
};

export default SupportChat;
